<template lang="pug">
div
  sharing-embed
  v-divider.basic500.my-5
  sharing-qr-code
  v-divider.basic500.my-5
  sharing-seo

</template>

<script>
import SharingEmbed from '@/components/donation/campaign/SharingEmbed.vue'
import SharingQrCode from '@/components/donation/campaign/SharingQrCode.vue'
import SharingSeo from '@/components/donation/campaign/SharingSeo.vue'

export default {
  name: 'ManageCampaignSharing',
  components: { SharingEmbed, SharingQrCode, SharingSeo },
}
</script>

<style scoped>

</style>